import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { action } from 'satcheljs';

const removePersonaFromWell = action(
    'removePersonaFromWell',
    (
        targetRecipientWell: RecipientWellWithFindControlViewState,
        personaToRemove: FindRecipientPersonaType,
        shouldRemoveAllOccurrences: boolean = false
    ) => ({
        targetRecipientWell,
        personaToRemove,
        shouldRemoveAllOccurrences,
    })
);

export default removePersonaFromWell;
